export default "__VITE_ASSET__7e3df932__"